import { apiClient } from '@/lib/api'

const PACKAGES_BASE = '/v1/billings/packages'

/**
 * Billing Packages API (Superadmin only)
 * CRUD operations for payment packages
 */

// Get all packages with filters
export const getPackages = async (params = {}) => {
  const response = await apiClient.get(`${PACKAGES_BASE}/`, { params })
  return response
}

// Get single package by ID
export const getPackage = async (id) => {
  const response = await apiClient.get(`${PACKAGES_BASE}/${id}/`)
  return response
}

// Create new package
export const createPackage = async (data) => {
  const response = await apiClient.post(`${PACKAGES_BASE}/`, data)
  return response
}

// Update package (full)
export const updatePackage = async (id, data) => {
  const response = await apiClient.put(`${PACKAGES_BASE}/${id}/`, data)
  return response
}

// Update package (partial)
export const patchPackage = async (id, data) => {
  const response = await apiClient.patch(`${PACKAGES_BASE}/${id}/`, data)
  return response
}

// Delete package
export const deletePackage = async (id) => {
  const response = await apiClient.delete(`${PACKAGES_BASE}/${id}/`)
  return response
}
